import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { Store, storeType } from '../../types/slices/storeType'

type shearchKFCType = {
    showModal: boolean
    productsCart: [],
    productsCount: number
    isLoading: boolean
    action: string
}

const initialState: shearchKFCType =
{
    showModal: false,
    productsCart: [],
    productsCount: 0,
    isLoading: false,
    action: ''
}

const shearchKFCSlice = createSlice({
    name: 'shearchKFCSlice',
    initialState,
    reducers: {
        openModalSearchKFC (state, { payload }: { payload: boolean}) {
            state.showModal = payload
        },
        onSetProductsCount (state, { payload }: { payload: number }) {
            state.productsCount = payload
        },
        onSetProducts (state, { payload }: { payload: [] }) {
            state.productsCart = payload
        },
        onSetLoading (state, { payload }: { payload: boolean}) {
            state.isLoading = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectSearchKFCState = (state: RootState) => state.shearchKFCSlice
export default shearchKFCSlice.reducer
export const {
    openModalSearchKFC,
    onSetProducts,
    onSetProductsCount,
    onSetLoading,
    setAction,
} = shearchKFCSlice.actions
